import { render, staticRenderFns } from "./LaporanPembayaranCicilanView.vue?vue&type=template&id=2cb824ac"
import script from "./LaporanPembayaranCicilanView.vue?vue&type=script&lang=js"
export * from "./LaporanPembayaranCicilanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports